import React, { useEffect, useState } from 'react';
import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import Carousel from './Carousel';
import ArticleView from './ArticleView';
import axios from 'axios';
import VideoView from './VideoView';
import IframeView from './IframeView';
import Play from '../../../assets/play.png';
import Slider from 'react-slick';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ModalVideo from 'react-modal-video';
import useMoengage from '../../../hooks/useMoengage';
import MyJobsFooter from '../../MyJobsStatus/components/MyJobsFooter';
import KnowledgeCentreConstants, {
  SHARE_OPTIONS,
  VIEW_TYPES,
  ANALYTICS_EVENTS,
} from '../../../constants/MitraContentConstants';

import DialolPopup from './DialogPopup';
import { ConstructionOutlined } from '@mui/icons-material';
import { styled } from '@mui/system';

const PAGE_TITLE = 'Knowledge Centre';
const MODE = SHARE_OPTIONS.WHATSAPP;

const Styleddiv = styled('div')({
  marginTop: '50px',
  width: '100%',
  // maxWidth:'340em',
  // marginLeft: '-10px'
});

function KnowledgeCentre() {
  const [isLoading, setIsLoading] = useState(true);
  const [playing, setPlaying] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [currentVideoId, setCurrentVideoId] = React.useState('rZsYkVsf1fU');
  const [userId, setUserId] = useState('');
  const [createMoengageUser, trackEvent, triggerContentInteractedEvent] = useMoengage();
  const [share, setShare] = React.useState(false);
  const [currentLink, setCurrentLink] = React.useState('link not available');
  const [error, setError] = useState(false);
  const [likedItems, setLikedItems] = useState([]);

  const getUpdatedSelectedLikeButton = id => {
    const items = likedItems.slice();
    const index = likedItems.indexOf(id);
    if (index >= 0) {
      items.splice(index, 1);
      setLikedItems(items);
    } else {
      items.push(id);
      setLikedItems(items);
    }
  };

  // Monagaege Events.
  const watchVideo = () => {
    window.open('https://uploads-a.vahan.co/XyquHz-2359-fbfatx.n3f04.mp4');
    triggerContentInteractedEvent(ANALYTICS_EVENTS.WATCH_VIDEO_CLICK, {
      page: PAGE_TITLE,
    });
  };

  let sliderImageClasses = ['view', 'slider_image1'];
  sliderImageClasses = sliderImageClasses.join(' ');

  const handleClickOpen = id => {
    setOpen(true);
    setCurrentVideoId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickShare = (view, type) => {
    setShare(true);
    if (type === VIEW_TYPES.ARTICLE) {
      setCurrentLink(view.url);
      triggerContentInteractedEvent(ANALYTICS_EVENTS.ARTICLE_SHARE_BUTTON_CLICK, {
        content_url:view.url,
        container_position: view.containerPosition,
        mode: MODE,
      });
    } else if (type === VIEW_TYPES.VIDEO) {
      setCurrentLink(view.url);
      triggerContentInteractedEvent(ANALYTICS_EVENTS.VIDEO_SHARE_BUTTON_CLICK, {
        content_url:view.url,
        container_position: view.containerPosition,
        mode: MODE,
      });
    } else if (type === VIEW_TYPES.IFRAME) {
      setCurrentLink(view.url);
      if (view.id === '2') {
        triggerContentInteractedEvent(ANALYTICS_EVENTS.DYNAMIC_VIDEO_SHARE_BUTTON_CLICK, {
          content_url:view.url,
          container_position: view.containerPosition,
          mode: MODE,
        });
      } else {
        triggerContentInteractedEvent(ANALYTICS_EVENTS.GAME_SHARE_BUTTON_CLICK, {
          content_url:view.url,
          container_position: view.containerPosition,
          mode: MODE,
        });
      }
    }
  };

  const handleCloseShare = () => {
    setShare(false);
  };

  useEffect(() => {
    console.log('Entering knowledgeCentre page: ');
    const paramString = window.location.href.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    let userIdParam;
    queryString.forEach((value, key) => {
      if (key === 'userId') userIdParam = value;
    });
    console.log('UserId: ', userIdParam);
    if (!userIdParam) {
      setError('Service unavailable');
    } else {
      async function fetchUserInfo(endPoint, query) {
        const config = {
          method: 'get',
          url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
            'Access-Control-Allow-Headers':
              'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            'Cache-Control': null,
            'X-Requested-With': null,
          },
        };

        return axios(config).then(response => {
          if (response.status === 200) {
            return response.data;
          }
          throw new Error('Server Error');
        });
      }

      fetchUserInfo('user_details', `userId=${userIdParam}`)
        .then(userData => {
          createMoengageUser(userIdParam, userData.name, userData.phoneNumber);
          console.log('Created Mongaege User: ', userData);
        })
        .catch(e => {
          console.log(e.toString());
          setError(e.toString());
          // setIsLoading(false);
          // setTimeout(() => Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userIdParam}`}), 5000);
        });
      setIsLoading(false);
      setUserId(userIdParam);
    }
  }, []);

  const renderKnowledgeCentre = (view, index) => {
    console.log('view', view, index);
    switch (view.type) {
      case VIEW_TYPES.CAROUSEL:
        return (
          <Styleddiv key={index}>
            <Carousel post={view.videoList} />
          </Styleddiv>
        );
      case VIEW_TYPES.ARTICLE:
        return (
          <Styleddiv key={index}>
            <ArticleView
              article={view}
              likedItems={likedItems}
              getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}
              handleClickShare={handleClickShare}
            />
          </Styleddiv>
        );
      case VIEW_TYPES.VIDEO:
        return (
          <Styleddiv key={index}>
            <VideoView
              sliderImageClasses={sliderImageClasses}
              video={view}
              handleClickOpen={handleClickOpen}
              likedItems={likedItems}
              getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}
              handleClickShare={handleClickShare}
            />{' '}
          </Styleddiv>
        );
      case VIEW_TYPES.IFRAME:
        return (
          <Styleddiv key={index}>
            <IframeView
              frame={view}
              likedItems={likedItems}
              getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}
              handleClickShare={handleClickShare}
            />
          </Styleddiv>
        );
      default:
        return null;
    }
  };

  return isLoading ? (
    <AnimatedLoader />
  ) : (
    <div className='my_knowledge_centre'>
      <div className='knowledge_centre_container'>
        <p
          style={{
            paddingInlineStart: '3%',
            paddingTop: '10%',
            marginLeft: '15px',
            width: '100%',
            height: '30px',
            fontFamilyReactPlayer: 'Open Sans',
            fontSize: '20px',
            lineHeight: '150%',
            verticalAlign: 'Top',
            alignContent: 'Left',
          }}
        >
          <b>Mitra Shots</b>
        </p>

        {/*{KnowledgeCentreConstants.VIEW_LIST.map((view, index) =>*/}
        {/*  view.type === VIEW_TYPES.CAROUSEL ? (*/}
        {/*    <Styleddiv>*/}
        {/*      <Carousel post={view.videoList} />*/}
        {/*    </Styleddiv>*/}
        {/*  ) : view.type === VIEW_TYPES.ARTICLE ? (*/}
        {/*    <Styleddiv>*/}
        {/*      <ArticleView*/}
        {/*        article={view}*/}
        {/*        likedItems={likedItems}*/}
        {/*        getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}*/}
        {/*        handleClickShare={handleClickShare}*/}
        {/*      />*/}
        {/*    </Styleddiv>*/}
        {/*  ) : view.type === VIEW_TYPES.VIDEO ? (*/}
        {/*    <Styleddiv>*/}
        {/*      <VideoView*/}
        {/*        sliderImageClasses={sliderImageClasses}*/}
        {/*        video={view}*/}
        {/*        handleClickOpen={handleClickOpen}*/}
        {/*        likedItems={likedItems}*/}
        {/*        getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}*/}
        {/*        handleClickShare={handleClickShare}*/}
        {/*      />{' '}*/}
        {/*    </Styleddiv>*/}
        {/*  ) : view.type == VIEW_TYPES.IFRAME ? (*/}
        {/*    <Styleddiv>*/}
        {/*      <IframeView*/}
        {/*        frame={view}*/}
        {/*        likedItems={likedItems}*/}
        {/*        getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}*/}
        {/*        handleClickShare={handleClickShare}*/}
        {/*      />*/}
        {/*    </Styleddiv>*/}
        {/*  ) : null,*/}
        {/*)}*/}

        {KnowledgeCentreConstants.VIEW_LIST.map(renderKnowledgeCentre)}

        <>
          <ModalVideo
            channel='youtube'
            autoplay
            isOpen={open}
            videoId={currentVideoId}
            theme='dark'
            onClose={() => setOpen(false)}
          />
        </>

        <DialolPopup shareUrl={currentLink} open={share} onClose={handleCloseShare} />

        <br />
        <MyJobsFooter watchVideo={watchVideo} />
      </div>
    </div>
  );
}

export default KnowledgeCentre;
